import React, {useEffect} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Iframe from 'react-iframe';
import {Helmet} from "react-helmet";
import ScrollAnimation from 'react-animate-on-scroll';

import ContactForm from '../components/ContactForm';

import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import BusinessIcon from '@material-ui/icons/Business';
import LocationCityOutlinedIcon from '@material-ui/icons/LocationCityOutlined';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg2,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    map: {
        height: "100%",
        minHeight: "385px",
        overflow: "hidden",
        position: "relative",
        border: `0px solid ${theme.palette.secondary.main}`
    },
    formContainer: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
}))


export default function Contact(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

    const setMenuSelected = props.setMenuSelected;
    useEffect(() => {
        if (setMenuSelected) {
            window.scrollTo(0, 0);
            setMenuSelected("contact");
        }

    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>Contact - house renovation & interior decoration</title>
                <meta name="description" key="description"
                      content="9446 Onion Patch Drive Burke, Virginia 22015. TechnoConstruction1@gmail.com. +1 (703) 929-6163 & +1 (202) 909-6603"/>
                <meta property="og:title" key="og:title"
                      content="9446 Onion Patch Drive Burke, Virginia 22015. TechnoConstruction1@gmail.com. +1 (703) 929-6163 & +1 (202) 909-6603"/>
            </Helmet>

            <div className={classes.formContainer}>
                <ContactForm/>
            </div>


            <Grid container direction="column" className={classes.container} id="contact">

                <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                    <Grid item>
                        <Typography component="h1" variant="h1" paragraph>let's Get In Touch</Typography>
                    </Grid>
                </ScrollAnimation>

                <Grid item style={{marginTop: "50px"}}>
                    <Grid item container direction="row" spacing={matchesSM ? 0 : 5}>
                        <Grid item md={6}>
                            <Grid item container direction="column">
                                <Grid item>
                                    <Typography variant="body1">
                                        We are always glad to cooperate and are ready to excute any project considering
                                        all Your
                                        wishes with the application of our many years of experience.
                                    </Typography>
                                </Grid>
                                <Grid item style={{marginTop: "50px"}}>
                                    <Grid item container direction="column">

                                        <Grid item>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <LocationOnOutlinedIcon/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body1">
                                                        &nbsp;9446 Onion Patch Drive <br/> Burke, Virginia 22015
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <MailOutlineOutlinedIcon/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body1">
                                                        &nbsp;TechnoConstruction1@gmail.com
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item style={{marginBottom: "25px"}}>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <SmartphoneOutlinedIcon/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body1">
                                                        +1 (202) 909-6603
                                                        <br/>
                                                        +1 (703) 929-6163
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} style={{
                            width: "100%",
                            marginTop: matchesSM ? "50px" : null
                        }}>
                            <Grid item container className={classes.map}>
                                <Iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3111.010535956628!2d-77.27247612275521!3d38.76346235459382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6523c1a6a21c9%3A0x3808041641a66b28!2s9446%20Onion%20Patch%20Dr%2C%20Burke%2C%20VA%2022015%2C%20USA!5e0!3m2!1sen!2suk!4v1694027950471!5m2!1sen!2suk"
                                    width="100%" frameBorder="0" allowFullscreen="" ariaHidden="false" tabIndex="0"
                                    loading="lazy"/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </React.Fragment>

    );
}
